import React, {useCallback, useEffect, useState} from 'react';
import {Dropdown} from "semantic-ui-react";
import './styles.scss';
import {apiPost} from "../../services/apiClient";
import throttle from 'lodash.throttle';

const CreatorSearchDropdown = (
    {
        className,
        name,
        value,
        disabled,
        onChange,
        placeholder,
        error
    }
) => {
    const [options, setOptions] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);

    const searchDataFunc = (text) => {
        if (!text || text.trim() === '' || text.length < 2) {
            setOptions([]);
            return;
        }

        apiPost('admin/companies/ref/users/search', { 
            searchText: text || ''
        }).then(data => {
            const serverItems = (data.entries || []).map(user => ({
                key: user.login,
                value: user.login,
                text: `${user.fullName} (${user.login})`,
                data: { 
                    login: user.login,
                    fullName: user.fullName
                }
            }));
            
            setOptions(serverItems);
            
            // Если есть текущее значение и оно совпадает с одним из найденных пользователей,
            // устанавливаем его как выбранного
            if (value && value.trim() !== '') {
                const foundUser = serverItems.find(item => item.data.login === value);
                if (foundUser && (!selectedUser || selectedUser.data.login !== value)) {
                    setSelectedUser(foundUser);
                    setSearchQuery(`${foundUser.data.fullName} (${foundUser.data.login})`);
                }
            }
        }).catch((e) => {
            console.log('Ошибка поиска инициаторов:', e);
            setOptions([]);
        });
    };

    const searchData = useCallback(throttle(searchDataFunc, 600), []);

    const onChangeValue = (e, {value: selectedValue}) => {
        if (!selectedValue) {
            onChange(name, '');
            setSearchQuery('');
            setSelectedUser(null);
            return;
        }
        
        // Находим выбранный элемент в текущих опциях
        const selected = options.find(opt => opt.value === selectedValue);
        if (selected && selected.data) {
            setSelectedUser(selected);
            onChange(name, selectedValue);
            setSearchQuery(`${selected.data.fullName} (${selected.data.login})`);
        } else {
            // Если не нашли в опциях, просто устанавливаем значение
            onChange(name, selectedValue);
        }
    };

    // Загружаем данные для отображения выбранного пользователя при изменении value
    useEffect(() => {
        if (value && value.trim() !== '') {
            // Если есть значение (логин), проверяем, соответствует ли оно выбранному пользователю
            if (!selectedUser || selectedUser.data.login !== value) {
                // Если нет выбранного пользователя или логин не совпадает,
                // пытаемся найти его через поиск
                if (value.length >= 2) {
                    // Используем прямой вызов функции поиска, чтобы избежать проблем с зависимостями
                    searchDataFunc(value);
                } else {
                    // Если логин слишком короткий, просто показываем его
                    setSearchQuery(value);
                }
            } else {
                // Если выбранный пользователь соответствует значению, обновляем поисковый запрос
                setSearchQuery(`${selectedUser.data.fullName} (${selectedUser.data.login})`);
            }
        } else {
            setSelectedUser(null);
            setSearchQuery('');
        }
    }, [value, selectedUser]);

    useEffect(() => {
        if (searchQuery && searchQuery.trim() !== '' && searchQuery.length >= 2) {
            const expectedDisplayText = selectedUser ? `${selectedUser.data.fullName} (${selectedUser.data.login})` : '';
            // Запускаем поиск только если поисковый запрос отличается от отображаемого текста выбранного пользователя
            if (searchQuery !== expectedDisplayText) {
                searchData(searchQuery);
            }
        } else {
            setOptions([]);
        }
    }, [searchQuery]);

    // Загружаем начальные данные при фокусе, если нет поискового запроса
    const handleFocus = () => {
        if (!searchQuery || searchQuery.trim() === '') {
            // При фокусе не загружаем данные, ждем ввода пользователя
        }
    };

    return (
        <div style={{ position: 'relative' }}>
            <Dropdown
                error={error}
                className={`selection input-dropdown ${className || ''}`}
                placeholder={placeholder || 'Введите логин для поиска'}
                fluid
                selection
                name={name}
                search={() => options}
                searchQuery={searchQuery}
                onSearchChange={(e, {searchQuery: newQuery}) => {
                    setSearchQuery(newQuery);
                    if (newQuery && newQuery.trim() !== '' && newQuery.length >= 2) {
                        searchData(newQuery);
                    } else {
                        setOptions([]);
                    }
                }}
                onFocus={handleFocus}
                disabled={disabled}
                options={options}
                value={value || null}
                noResultsMessage={'Введите логин для поиска (минимум 2 символа)'}
                onChange={onChangeValue}
                selectOnNavigation={false}
                selectOnBlur={false}
                allowAdditions={false}
                onBlur={() => {
                    // Восстанавливаем значение выбранного пользователя
                    if (selectedUser) {
                        setSearchQuery(`${selectedUser.data.fullName} (${selectedUser.data.login})`);
                    } else if (!value || value.trim() === '') {
                        setSearchQuery('');
                    } else {
                        // Если есть значение, но нет выбранного пользователя, показываем логин
                        setSearchQuery(value);
                    }
                }}
                style={{ position: 'relative' }}
            />
            {/* Собственный крестик */}
            {value && value.trim() !== '' && (
                <div
                    style={{
                        position: 'absolute',
                        right: '0.5em',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 1000,
                        cursor: 'pointer',
                        color: '#999',
                        fontSize: '18px',
                        fontWeight: '300',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'transparent',
                        border: 'none',
                        userSelect: 'none'
                    }}
                    onClick={() => {
                        onChange(name, '');
                        setSearchQuery('');
                        setSelectedUser(null);
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.color = '#666';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.color = '#999';
                    }}
                >
                    ×
                </div>
            )}
        </div>
    );
};

export default CreatorSearchDropdown;



// WEBPACK FOOTER //
// ./App/components/Dropdowns/CreatorSearchDropdown.jsx